import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NavigationState } from '../reducers/navigation.reducer';

export const selectNavigationState = createFeatureSelector<NavigationState>('navigation');

export const selectIsNavigationLoadingModules = createSelector(selectNavigationState, state => state.routeLoadingCount > 0);
